import { CSSProperties } from 'react';

const logo: CSSProperties = {
    height: '200px'
}

const container: CSSProperties = {
    alignContent: 'center',
    alignItems: 'center',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100vw',
    height: '100vh'
}

export const styles = {
    container, logo
}


// WEBPACK FOOTER //
// ./src/screens/home.styles.ts